<template>
  <div class="product-details-content-category-modal p-5">
    <form>
      <snow-input
        v-model="form.name"
        :errors="errors.name"
        id="name"
        class="mb-2"
        type="text"
        label="Categoria"
      />
      <span class="text-dark-40 fs-14">
        O nome da categoria aparece na sua área de membros
      </span>

      <div class="snow-submit-buttons mt-7">
        <snow-button
          text="Cancelar"
          variant="gray"
          size="lg"
          @click="$emit('close')"
        >
          Cancelar
        </snow-button>
        <snow-button
          size="lg"
          text="Salvar"
          @click="submit"
          :disabled="form.name.length > 70"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  props: {
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["name", "product_id"], {
        name: this.category.name ? this.category.name : "",
        product_id: this.$route.params.id
      })
    };
  },
  methods: {
    submit() {
      this.loading = true;
      if (!this.category.name) {
        this.$store
          .dispatch("membersCategories/post", this.form)
          .then(response => {
            this.$message.success("Salvo com sucesso");
            this.$emit("success", response.data);
          })
          .catch(error => {
            this.errors = error?.response?.data || this.errors;
            this.handleErrors(error, "", "Erro ao salvar categoria");
            this.loading = false;
          });
      } else {
        this.form.id = this.category.id;
        this.$store
          .dispatch("membersCategories/put", this.form)
          .then(() => {
            this.$message.success("Editado com sucesso");
            this.$emit("success");
          })
          .catch(error => {
            this.errors = error?.response?.data || this.errors;
            this.handleErrors(error, "", "Erro ao salvar categoria");
            this.loading = false;
          });
      }
    }
  }
};
</script>
